import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Stack, Box, Typography } from '@mui/material'
import { J1RightarrowD } from '@e3dc-react/icons'
import useModals from 'src/Hooks/useModals'
import { TargetSocDto } from '../../dto'
import { useTargetSoc } from '../../hooks'
import { ChargingScheduleWrapper } from '../charging-schedule/form'

interface VehicleDetailsProps {
  vehicleId: string
  installationId?: string
  chargeLimitMax?: number
}

/***
 * Component to display the state of charge card in vehicle details
 */
const StateOfChargeCard: React.FC<VehicleDetailsProps> = ({ vehicleId, installationId, chargeLimitMax }) => {
  const { t } = useCustomTranslation()
  const { openChargeModal } = useModals()
  const { targetSoc, changeTargetSoc, hasError: targetSocHasError } = useTargetSoc(Number(vehicleId), Number(installationId))
  const chargeLimitMinLabel = t('emobility.vehicle-integration.state-of-charge.set-soc')
  const chargeLimitMinMessage = [chargeLimitMinLabel, targetSocHasError || targetSoc === null ? '--' : targetSoc + ' %'].join(' ')

  const handleEdit = (): void => {
    if (!installationId) return
    openChargeModal({
      vehicleId: Number(vehicleId),
      installationId: Number(installationId),
      targetSoc: targetSoc,
      afterSaveCallback: (targetSoc: TargetSocDto['targetSoC']) => changeTargetSoc(targetSoc),
      chargeLimitMax,
    })
  }

  return (
    <ChargingScheduleWrapper sx={{ mt: 4 }} onClick={handleEdit}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h3">{chargeLimitMinMessage}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <J1RightarrowD />
        </Box>
      </Stack>
    </ChargingScheduleWrapper>
  )
}

export default StateOfChargeCard
